import React, { Component } from 'react';
import { 
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Navbar, 
  NavbarToggler, 
  NavbarBrand, 
  Nav, 
  NavItem,
  NavLink,
  UncontrolledDropdown } from 'reactstrap';
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types';

export default class NavbarMenu extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {

    var loginButton;
    if (this.props.authenticated) {
      loginButton = <NavLink tag={Link} to="/logout">Logout</NavLink>;
    } else {
      loginButton = <NavLink tag={Link} to="/login">Login</NavLink>;
    }

    return (
      <div>
        <Navbar className="navbar-orange" expand="md">
          <NavbarBrand className="navbar-brand">eTeachMe</NavbarBrand>
          <NavbarToggler className="navbar-toggle" onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink tag={Link} to="/">Home</NavLink>
              </NavItem>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  Tools
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem>
                    <NavLink tag={Link} to="/ita">Grammar Analisys</NavLink>
                  </DropdownItem>
                  <DropdownItem>
                    <NavLink tag={Link} to="/mathEquation">Equation Solver</NavLink>
                  </DropdownItem>
                  <DropdownItem>
                    <NavLink tag={Link} to="/mathExpression">Expression Solver</NavLink>
                  </DropdownItem>
                  <DropdownItem>
                    <NavLink tag={Link} to="/classroom">My Google Classroom</NavLink>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavItem>
                {loginButton}
              </NavItem>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  Options
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem>
                    Profile
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

NavbarMenu.propTypes = {
  authenticated: PropTypes.bool.isRequired //variable that indicate if the user is authenticated
}
